import { GridColumn, GridRow } from 'app/layouts/grid';
import { BasicInfoSection } from 'app/shared/info-section/basic';
import { DetailItem } from 'app/shared/info-section/item';
import { toReadableNumber } from 'app/shared/utils/number';
import { useAutomationJourneyService } from 'hooks/automation/journey';
import { useAutomationTemplateService } from 'hooks/automation/template';
import React, { useEffect, useState } from 'react';

export const AutomationTemplateStat = ({ template_id }) => {
  const { fetchJourneys } = useAutomationJourneyService();
  const { fetchTemplate } = useAutomationTemplateService();
  const [stat, setStat] = useState({});

  useEffect(() => {
    if (!template_id || isNaN(template_id)) return;
    Promise.all([
      fetchTemplate(template_id),
      fetchJourneys({ query_string: `status=started&template_id=${template_id}&count=1` }),
      fetchJourneys({ query_string: `status=completed&template_id=${template_id}&count=1` })
    ]).then(([{ template }, { size: active }, { size: completed }]) => {
      const { conversion } = template || {};
      setStat(() => ({
        conversions: conversion?.count || 0,
        conversion_value: conversion?.value || 0,
        active,
        completed
      }));
    });

    return () => {
      setStat(() => ({}));
    };
  }, [template_id]);

  return (
    <BasicInfoSection title="Journey stats">
      <div>
        <GridRow num_of_columns={1}>
          <GridColumn>
            <DetailItem title="Active Journeys">{toReadableNumber(stat.active)}</DetailItem>
          </GridColumn>
        </GridRow>
        <GridRow num_of_columns={1}>
          <GridColumn>
            <DetailItem title="Completed Journeys">{toReadableNumber(stat.completed)}</DetailItem>
          </GridColumn>
        </GridRow>
        <GridRow num_of_columns={1}>
          <GridColumn>
            <DetailItem title="Total Conversions">{toReadableNumber(stat.conversions)}</DetailItem>
          </GridColumn>
        </GridRow>
        <GridRow num_of_columns={1}>
          <GridColumn>
            <DetailItem title="Conversion value">
              {toReadableNumber(stat.conversion_value)}
            </DetailItem>
          </GridColumn>
        </GridRow>
      </div>
    </BasicInfoSection>
  );
};
